import * as React from "react";

import {
	createStyles,
	withStyles,
	WithStyles,
	Theme,
} from "@material-ui/core/styles";
import { Grid, Button, GridProps } from "@material-ui/core";

// NPM
import clsx from "clsx";
import { ReactSketchCanvas } from "react-sketch-canvas";

// Contexts
import { usePaymentManager } from "../../contexts/PaymentManager.Context";

// Component
import Utility from "../../domain/classes/Utility";

// Components
import StyledProcessPaymentButton from "../common/ProcessPaymentButton.Component";
import { Alert } from "@material-ui/lab";

// Components

export const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: "flex",
			position: "relative",
			marginTop: theme.spacing(1),
		},
		signButton: { margin: "auto" },
	});

export interface CreditCardBackActionButtonsProps extends GridProps {}

const CreditCardBackActionButtons: React.FC<
	CreditCardBackActionButtonsProps & WithStyles<typeof styles>
> = ({ classes, className }) => {
	const { canvasRef } = usePaymentManager();

	const handleSignatureClear = () => {
		((canvasRef as React.RefObject<ReactSketchCanvas>)
			.current as ReactSketchCanvas).clearCanvas();
	};

	return (
		<Grid
			item
			xs={12}
			className={clsx(classes.root, className)}
			container
			justify="center"
			spacing={1}
		>
			<Grid container item xs={12} justify="center" spacing={1}>
				<Grid item>
					<Button
						variant="outlined"
						color="primary"
						className={classes.signButton}
						onClick={handleSignatureClear}
					>
						Clear
					</Button>
				</Grid>
				<Grid item>
					<StyledProcessPaymentButton />
				</Grid>
			</Grid>
			<Grid container item xs={12}>
				<Alert severity="info">
					Please use your finger or mouse to sign in the signature
					pad.
				</Alert>
			</Grid>
		</Grid>
	);
};

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("CreditCardBackActionButtons"),
})(CreditCardBackActionButtons);
